import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.querySelectorAll('a[href], button').forEach((el) => {
      if (!el.getAttribute('aria-label') || !el.getAttribute('aria-label').trim()) {
        const text = el.textContent ? el.textContent.trim() : '';
        const title = el.getAttribute('title') ? el.getAttribute('title').trim() : '';
        const label = text || title || 'Article link';
        el.setAttribute('aria-label', label);
      }
    });
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
